module.exports = __webpack_public_path__ + "static/Siplo-8daf4025e230b57eb435f5b0680d32fe.png";